function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { getParameterByName, setGetParam } from './includes/helpers';
import SelectComponent from './includes/SelectComponent';
var FILTER_SELECT = '[data-component="filterSelect"]';
var FILTER_SELECT_MENU = '[data-element="filterSelectMenu"]';
var FILTER_SELECT_CTA = '[data-element="filterSelectCta"]';
var HIDDEN_CLASS = 'u-hidden';
var FilterSelect = /*#__PURE__*/function (_SelectComponent) {
  function FilterSelect(component, selector) {
    var _this;
    _classCallCheck(this, FilterSelect);
    _this = _callSuper(this, FilterSelect, [component, selector]);
    _this.menu.addEventListener('click', _this.handleMenuItems.bind(_this));
    _this.menuCtas.forEach(function (item) {
      _this.setDefaultInputFieldOnLoad(item);
    });
    return _this;
  }
  _inherits(FilterSelect, _SelectComponent);
  return _createClass(FilterSelect, [{
    key: "setDefaultInputFieldOnLoad",
    value: function setDefaultInputFieldOnLoad(item) {
      var value = item.dataset.value;
      if (value === getParameterByName('et') || value === getParameterByName('sa') || value === getParameterByName('nar') || value === getParameterByName('nar') || value === getParameterByName('region') || value === getParameterByName('sp') || value === getParameterByName('reg') || value === getParameterByName('region') || value === getParameterByName('subCat') || value === getParameterByName('cat') || value === getParameterByName('newsletterCategory')) {
        this.inputField.textContent = item.textContent;
        this.inputField.dataset.value = item.dataset.value;
        this.removeCtaSiblingsOnLoad(item);
      }
    }
  }, {
    key: "removeCtaSiblingsOnLoad",
    value: function removeCtaSiblingsOnLoad(el) {
      this.menuCtas.forEach(function (cta) {
        if (cta.dataset.value !== el.dataset.value) {
          cta.parentNode.classList.remove(HIDDEN_CLASS);
        } else {
          cta.parentNode.classList.add(HIDDEN_CLASS);
        }
      });
    }
  }, {
    key: "hideCurrentFromListOnClick",
    value: function hideCurrentFromListOnClick(target) {
      var _this2 = this;
      var menu = target.closest(FILTER_SELECT_MENU);
      var menuCtas = Array.from(menu.querySelectorAll(FILTER_SELECT_CTA));
      menuCtas.forEach(function (cta) {
        if (_this2.inputField.dataset.value === cta.dataset.value) {
          cta.parentNode.classList.add(HIDDEN_CLASS);
        } else {
          cta.parentNode.classList.remove(HIDDEN_CLASS);
        }
      });
    }
  }, {
    key: "refreshOnCLick",
    value: function refreshOnCLick() {
      setTimeout(function () {
        window.location.reload();
        return false;
      }, 100);
    }
  }, {
    key: "handleMenuItems",
    value: function handleMenuItems(event) {
      var target = event.target;
      if (target.matches(FILTER_SELECT_CTA)) {
        event.preventDefault();
        var URLParam = target.dataset.value;
        var GETParamValue = target.dataset.param;
        document.body.classList.add('is-loading');
        setGetParam(GETParamValue, URLParam);
        this.refreshOnCLick();
        this.inputField.textContent = target.textContent;
        this.inputField.dataset.value = target.dataset.value;
        this.hideCurrentFromListOnClick(target);
        this.close();
      }
    }
  }]);
}(SelectComponent);
Array.from(document.querySelectorAll(FILTER_SELECT)).forEach(function (filter) {
  new FilterSelect(filter, FILTER_SELECT);
});